import { render, staticRenderFns } from "./asset-tab-eventos.vue?vue&type=template&id=c77dd7f6&"
import script from "./asset-tab-eventos.vue?vue&type=script&lang=js&"
export * from "./asset-tab-eventos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c77dd7f6')) {
      api.createRecord('c77dd7f6', component.options)
    } else {
      api.reload('c77dd7f6', component.options)
    }
    module.hot.accept("./asset-tab-eventos.vue?vue&type=template&id=c77dd7f6&", function () {
      api.rerender('c77dd7f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consolidator/components/details-asset/asset-tab-eventos.vue"
export default component.exports